import { defineCopy } from "@tami/core/intl";

import { CREATORS_SCRIPT_COPY_EN_US } from "./en-us/creators-script.copy";
import { CREATORS_SCRIPT_COPY_ES_ES } from "./es-es/creators-script.copy";

export const CREATORS_SCRIPT_COPY_PT_BR = {
  creatorsIntro: {
    narrative:
      "O quadro da Collab: quem você gerencia, com quanto alcance e com que acesso.",
  },
  creatorsSummary: {
    narrative:
      "Alcance somado e engajamento global do quadro inteiro, mais os assentos que você já usou.",
    callout:
      "O tamanho da sua Collab num número só — e quantos assentos sobram.",
  },
  creatorsOverview: {
    narrative:
      "Creator entra por convite e conecta as próprias redes. Sem planilha no meio.",
  },
  creatorsGrid: {
    narrative:
      "Um card por creator: foto, redes conectadas, seguidores, engajamento e o acesso que ele te deu.",
    callout:
      "A sua própria Collab também está no quadro — ela tem redes e conteúdo.",
  },
  creatorsInvite: {
    narrative:
      "Convite pendente fica visível até o creator aceitar — você não fica no escuro esperando.",
    callout:
      "Convidou e ainda não aceitou? O card fica lá, marcado.",
  },
} as const;

export const CREATORS_SCRIPT_COPY = defineCopy(CREATORS_SCRIPT_COPY_PT_BR, {
  "en-US": CREATORS_SCRIPT_COPY_EN_US,
  "es-ES": CREATORS_SCRIPT_COPY_ES_ES,
});
